<template>
  <div @click="onClick" style="display: inline-block;">
    <Card class="card" >
      <img :src="require(`@/assets/icons/${icon}`)" />
      <div>{{title}}</div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'IconCard',
  props: {
    title: String,
    icon: String
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  width: 280px;
  height: 280px;
  text-align: center;
  display: inline-block;
  margin: 75px 25px;
  cursor: pointer;

  img {
    height: 150px;
    width: 150px;
  }

  div {
    margin-top: 10px;
    font-size: large;
  }
}
</style>